import T from "ramda/es/T";
import compose from "ramda/es/compose";
import cond from "ramda/es/cond";
import map from "ramda/es/map";
import prop from "ramda/es/prop";
import reduceRight from "ramda/es/reduceRight";
import reverse from "ramda/es/reverse";
import { createActionList, formatActionToListItem, isActionType, mapIndexed, showActionTypeWithPayloadOf, typeP } from '../utils';
export const setStepFormatter = showActionTypeWithPayloadOf('step');
export const locationChangeFormatter = showActionTypeWithPayloadOf('pathname');
export const unregisterFieldFormatter = showActionTypeWithPayloadOf();
export const codelistFormatter = showActionTypeWithPayloadOf('codelistStoreKey');
const registerFieldFormatter = showActionTypeWithPayloadOf('fieldName');
const defaultFieldValueFormatter = showActionTypeWithPayloadOf('value');
const actionBatchFormatter = cond([
    [
        isActionType('REGISTER_FIELD'),
        registerFieldFormatter
    ],
    [
        isActionType('DEFAULT_FIELD_VALUE'),
        defaultFieldValueFormatter
    ],
    [
        T,
        typeP
    ]
]);
export const batchingReducerFormatter = compose(reduceRight(createActionList, 'BATCHING_REDUCER.BATCH:'), reverse, mapIndexed(formatActionToListItem), map(actionBatchFormatter), prop('payload'));
